// Use localhost for development, prepboxpro.com for production
const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
export const API_NODE_BASE_URL = process.env.REACT_APP_API_URL || (isLocalhost ? 'http://localhost:3001/api' : 'https://prepboxpro.com/api');
export const API_STATIC_BOOKS_URL = `${API_NODE_BASE_URL.replace('/api', '')}/api/stu/static_books`;
export const API_EMAIL_CAPTURE_WORKBOOK_URL = `${API_NODE_BASE_URL}/email-captures/workbook`;
export const API_EMAIL_CAPTURE_NEWSLETTER_URL = `${API_NODE_BASE_URL}/email-captures/newsletter`;
export const PAPER_FORM_URL = '/consultation';
export const S3_URL = 'https://pa-prepbox.s3.amazonaws.com/public';
export const S3_DATA_URL = `${S3_URL}/data`;
export const S3_QIMG_URL = 'https://prepanywhere.s3.amazonaws.com/qimages';
export const S3_VIDEOS_URL = `${S3_URL}/assets/videos`;
export const SLACK_WEBHOOK_1_URL = 'https://hooks.slack.com/services/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';
export const SLACK_WEBHOOK_2_URL = 'https://hooks.slack.com/services/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';
